export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right' | 'mouse';

type AnchoredTooltipPosition = Exclude<TooltipPosition, 'mouse'>;

interface ResolveTooltipPositionOptions {
  triggerRect: Pick<DOMRect, 'top' | 'right' | 'bottom' | 'left'>;
  boundaryRect?: Pick<DOMRect, 'top' | 'right' | 'bottom' | 'left'>;
  defaultPosition?: AnchoredTooltipPosition;
  fallbackPosition?: TooltipPosition;
  minOffset?: number;
}

const spaceByPosition = (
  rect: Pick<DOMRect, 'top' | 'right' | 'bottom' | 'left'>,
  boundaryRect: Pick<DOMRect, 'top' | 'right' | 'bottom' | 'left'>,
  position: AnchoredTooltipPosition
) => {
  switch (position) {
  case 'top':
    return rect.top - boundaryRect.top;
  case 'bottom':
    return boundaryRect.bottom - rect.bottom;
  case 'left':
    return rect.left - boundaryRect.left;
  case 'right':
    return boundaryRect.right - rect.right;
  default:
    return 0;
  }
};

export const resolveTooltipPosition = ({
  triggerRect,
  boundaryRect,
  defaultPosition = 'top',
  fallbackPosition = 'mouse',
  minOffset = 56
}: ResolveTooltipPositionOptions): TooltipPosition => {
  const viewportRect = {
    top: 0,
    left: 0,
    right: window.innerWidth,
    bottom: window.innerHeight
  };

  const effectiveBoundaryRect = boundaryRect ?? viewportRect;
  const availableSpace = spaceByPosition(
    triggerRect,
    effectiveBoundaryRect,
    defaultPosition
  );
  return availableSpace >= minOffset ? defaultPosition : fallbackPosition;
};
